import { Tent, Umbrella, Waves, type LucideIcon } from "lucide-react";

export interface AccommodationOption {
  id: string;
  label: string;
  icon: LucideIcon;
  amenities: string[];
}

export const ACCOMMODATION_OPTIONS: AccommodationOption[] = [
  {
    id: "cabana",
    label: "Cabanas",
    icon: Umbrella,
    amenities: ["Private riverfront", "Shaded seating", "Grill & table", "1 free parking spot"],
  },
  {
    id: "tubing",
    label: "All-day Tubing",
    icon: Waves,
    amenities: ["Unlimited floats", "Tube included", "Private river access"],
  },
  {
    id: "glamping_cabin",
    label: "Glamping",
    icon: Tent,
    amenities: ["Real beds", "Air conditioning", "Fire pit", "Riverside setting"],
  },
];

export function getAccommodation(id: string): AccommodationOption | undefined {
  return ACCOMMODATION_OPTIONS.find((o) => o.id === id);
}
